export const DEFAULT_CONTENT = {
  hero: {
    kicker: "Rundum · Dein Handwerkspartner in Aachen",
    line1: "Ehrlich.",
    line2: "Direkt.",
    line3: "Verlässlich.",
    subline:
      "Ich bin der Partner, der anpackt: Trockenbau, Verputzen, Innenausbau und Altbau-Koordination – sauber, ohne Schnickschnack und mit einem Wort, auf das du dich verlassen kannst.",
    bg_url:
      "https://images.unsplash.com/photo-1784294460266-ff0690c51861?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NjZ8MHwxfHNlYXJjaHwxfHxpbnRlcmlvciUyMHJvb20lMjBiZWZvcmUlMjByZW5vdmF0aW9ufGVufDB8fHx8MTc4NjgxOTcwN3ww&ixlib=rb-4.1.0&q=85",
    bg_opacity: 0.13,
  },
  marquee: [
    "Ehrlich. Direkt. Verlässlich.",
    "Trockenbau",
    "Verputzen",
    "Innenausbau",
    "Altbau-Sanierung",
    "Handgemacht in Aachen",
  ],
  marqueeBottom: {
    enabled: true,
    items: [
      "Ruf einfach durch",
      "Mo–Sa · meld dich einfach",
      "Ehrlich. Direkt. Verlässlich.",
      "Aachen & Umgebung",
      "Ein Anruf genügt",
    ],
  },
  about: {
    heading: "Moin, ich bin der Kopf hinter Rundum.",
    paragraphs: [
      "Ich mache das, weil ich Handwerk liebe, das man anfassen kann: Wände, die gerade sind. Putz, der hält. Räume, in denen man gern ist. Mit Erfahrung, ohne Schnickschnack – und immer sauber.",
      "Bei mir bekommst du eine ehrliche Ansage: was geht, was nicht geht und was es kostet. Keine leeren Versprechen, kein Marketing-Sprech. Wenn ich einen Termin mache, halte ich ihn. Und wenn irgendwo was klemmt, rufe ich dich an, bevor du fragen musst.",
      "Kurz gesagt: Ich helfe dir, das Ding zu wuppen – so, wie ich es bei mir zu Hause machen würde.",
    ],
    facts: [
      "Ein Ansprechpartner für alles",
      "Klare Ansage statt Kleingedrucktem",
      "Saubere Baustelle, versprochen",
    ],
    portrait_url:
      "https://images.pexels.com/photos/8961524/pexels-photo-8961524.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
    caption: "Bei der Arbeit · Aachen",
  },
  services: [
    {
      nr: "01",
      title: "Trockenbau",
      desc: "Wände, Decken und Trennwände – schnell, staubarm und millimetergenau.",
      icon: "Layers",
    },
    {
      nr: "02",
      title: "Verputzen",
      desc: "Glatt, strukturiert oder gefilzt: Putz, der hält und richtig gut aussieht.",
      icon: "PaintRoller",
    },
    {
      nr: "03",
      title: "Innenausbau",
      desc: "Vom Rohbau bis zum fertigen Raum – alles aus einer Hand, alles aufeinander abgestimmt.",
      icon: "DoorOpen",
    },
    {
      nr: "04",
      title: "Altbau-Sanierung",
      desc: "Ich koordiniere die komplette Sanierung und behalte den Überblick, damit du ruhig schlafen kannst.",
      icon: "Building2",
    },
  ],
  beforeAfter: {
    heading: "Egal, wie's vorher aussieht – wir machen das wieder fit.",
    text: "Aus Baustelle wird Zuhause. Zieh den Regler hin und her und sieh selbst, was aus einer runtergekommenen Bude werden kann.",
    caption: "Ziehen zum Vergleichen",
    items: [
      {
        id: "1",
        title: "Beispielprojekt",
        before_url:
          "https://images.unsplash.com/photo-1784294460266-ff0690c51861?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NjZ8MHwxfHNlYXJjaHwxfHxpbnRlcmlvciUyMHJvb20lMjBiZWZvcmUlMjByZW5vdmF0aW9ufGVufDB8fHx8MTc4NjgxOTcwN3ww&ixlib=rb-4.1.0&q=85",
        after_url:
          "https://images.unsplash.com/photo-1649083048770-82e8ffd80431?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxOTF8MHwxfHNlYXJjaHwxfHxtb2Rlcm4lMjBpbnRlcmlvciUyMHJvb20lMjBhZnRlciUyMHJlbm92YXRpb258ZW58MHx8fHwxNzg2ODE5NzA3fDA&ixlib=rb-4.1.0&q=85",
        video_url: "",
      },
    ],
  },
  contact: {
    heading: "Lass uns über dein Projekt quatschen.",
    text: "Kein Warteschleifen-Quatsch: Ruf einfach durch – oder schreib mir kurz, worum's geht. Wir schauen, was zu tun ist, und besprechen in Ruhe, wie wir dein Ding gewuppt kriegen.",
    phone: "+49 175 679825183",
    whatsapp: "49175679825183",
    whatsapp_text: "Hallo John, ich habe eine Anfrage zu einem Projekt.",
    availability: "Mo–Sa · meld dich einfach",
    address: "Rundum · Adalbertsteinweg 208 · 52066 Aachen",
  },
  businessCard: {
    tagline: "Ehrlich. Direkt. Verlässlich.",
    name: "John Lorquet",
    company: "Rundum",
    photo_url: "",
    activities: ["Trockenbau", "Verputzen", "Innenausbau", "Altbau-Sanierung"],
    street: "Adalbertsteinweg 208",
    city: "52066 Aachen",
    phone: "+49 175 679825183",
    whatsapp: "49175679825183",
    whatsapp_text: "Hallo John, ich habe deine Visitenkarte gescannt.",
    email: "hallo@rundum-dabau.de",
    website: "https://rundum-dabau.de",
  },
  legal: {
    impressum: [
      {
        h: "Angaben gemäß § 5 DDG",
        p: ["Rundum", "Inhaber: John Lorquet", "Adalbertsteinweg 208", "52066 Aachen"],
      },
      {
        h: "Kontakt",
        p: ["Telefon: +49 175 679825183", "E-Mail: hallo@rundum-dabau.de"],
      },
      {
        h: "Umsatzsteuer-ID",
        p: [
          "Umsatzsteuer-Identifikationsnummer gemäß § 27 a Umsatzsteuergesetz: [falls vorhanden – bitte eintragen]",
        ],
      },
      {
        h: "Verantwortlich für den Inhalt nach § 18 Abs. 2 MStV",
        p: ["John Lorquet, Anschrift wie oben"],
      },
      {
        h: "Hinweis",
        p: [
          "Bitte vor Veröffentlichung prüfen – insbesondere, ob eine USt-IdNr. angegeben werden muss.",
        ],
      },
    ],
    datenschutz: [
      {
        h: "1. Verantwortlicher",
        p: [
          "Rundum, John Lorquet, Adalbertsteinweg 208, 52066 Aachen",
          "Telefon: +49 175 679825183 · E-Mail: hallo@rundum-dabau.de",
        ],
      },
      {
        h: "2. Kontaktformular",
        p: [
          "Wenn du mir über das Kontaktformular schreibst, verarbeite ich deine Angaben (Name, Kontaktdaten, Nachricht) ausschließlich zur Beantwortung deiner Anfrage (Art. 6 Abs. 1 lit. b DSGVO). Deine Daten gebe ich nicht an Dritte weiter. Sie werden gelöscht, sobald sie für die Bearbeitung nicht mehr nötig sind.",
        ],
      },
      {
        h: "3. Hosting",
        p: [
          "Diese Website wird bei einem Hosting-Dienstleister betrieben. Dabei werden technisch notwendige Daten (z. B. IP-Adresse, Browsertyp, Zeitpunkt des Aufrufs) in Server-Logdateien verarbeitet (Art. 6 Abs. 1 lit. f DSGVO).",
        ],
      },
      {
        h: "4. Deine Rechte",
        p: [
          "Du hast das Recht auf Auskunft, Berichtigung, Löschung, Einschränkung der Verarbeitung, Datenübertragbarkeit und Widerspruch. Außerdem kannst du dich bei einer Datenschutz-Aufsichtsbehörde beschweren.",
        ],
      },
      {
        h: "Hinweis",
        p: [
          "Platzhalter-Fassung – bitte vor Veröffentlichung mit den echten Angaben und ggf. anwaltlicher Prüfung ergänzen.",
        ],
      },
    ],
  },
  seo: {
    title:
      "Rundum – Dein Handwerkspartner in Aachen | Trockenbau, Verputzen, Innenausbau",
    description:
      "Rundum in Aachen: Trockenbau, Verputzen, Innenausbau & Altbau-Sanierung. Ehrlich, direkt, verlässlich. Projekt besprechen: +49 175 679825183.",
    keywords:
      "Trockenbau Aachen, Verputzen Aachen, Innenausbau Aachen, Altbau Sanierung Aachen, Handwerker Aachen",
  },
};
